<script setup lang="ts">
import type { InputEventProps } from "@/types/inputEventProps";

const props = defineProps({
    label: {
        type: String,
        default: "",
        required: false,
    },
    value: {
        type: String,
        default: "",
        required: false,
    },
    name: {
        type: String,
        default: "",
        required: false,
    },
    type: {
        type: String,
        required: true,
    },
    checked: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["onInput"]);

function updateValue(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    emit("onInput", {
        value: inputElement.value,
        text: props.label,
        checked: inputElement.checked,
    } as InputEventProps);
}
</script>
<template>
    <input
        v-if="type === 'checkbox'"
        :type="type"
        :value="value"
        :id="value"
        :name="name"
        :class="{ 'is-active': checked }"
        @input="updateValue($event)"
        :checked="checked"
    />
    <label :for="value">
        {{ label }}
    </label>
</template>
